export const convertTabToQueryVariables = (tab: string) => {
	switch (tab) {
		case 'release-report-warnings':
			return {
				filter: 'OPEN_PULL_REQUEST' as const, // default this to open pull requests to keep flow happy. In warnings page we will fetch all 3 UNREVIEWED_CODE, OPEN_PULL_REQUEST, FAILING_BUILD when isShowWarnings is true
				isShowWarnings: true,
			};
		case 'release-report-all-issues':
			return {
				filter: 'ALL' as const,
				isShowWarnings: false,
			};
		case 'release-report-done':
			return {
				filter: 'DONE' as const,
				isShowWarnings: false,
			};
		case 'release-report-in-progress':
			return {
				filter: 'IN_PROGRESS' as const,
				isShowWarnings: false,
			};
		case 'release-report-todo':
			return {
				filter: 'TODO' as const,
				isShowWarnings: false,
			};
		default:
			// default to all issues column
			return {
				filter: 'ALL' as const,
				isShowWarnings: false,
			};
	}
};
